/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisableExtendedVersioningSettingsRequest,
    DisableExtendedVersioningSettingsRequestFromJSON,
    DisableExtendedVersioningSettingsRequestFromJSONTyped,
    DisableExtendedVersioningSettingsRequestToJSON,
} from './DisableExtendedVersioningSettingsRequest';
import {
    UpgradeRuleEtcResponse,
    UpgradeRuleEtcResponseFromJSON,
    UpgradeRuleEtcResponseFromJSONTyped,
    UpgradeRuleEtcResponseToJSON,
} from './UpgradeRuleEtcResponse';

/**
 * 
 * @export
 * @interface UpgradeRuleResponse
 */
export interface UpgradeRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    deviceTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    superGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    loaderVersionFirmwareId: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    fwVersionFirmwareId: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    uiVersionFirmwareId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    forceUpdate: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    sendAllFirmwares: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    customFirmware1VersionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    customFirmware2VersionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    customFirmware3VersionId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    deviceTypeForceUpdate: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    deviceTypeSendAllFirmwares: boolean | null;
    /**
     * 
     * @type {UpgradeRuleEtcResponse}
     * @memberof UpgradeRuleResponse
     */
    etc: UpgradeRuleEtcResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    enableLoaderCondition: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    minLoaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    maxLoaderVersion: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    enableFwCondition: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    minFwVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    maxFwVersion: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeRuleResponse
     */
    enableUiCondition: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    minUiVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponse
     */
    maxUiVersion: string | null;
    /**
     * 
     * @type {DisableExtendedVersioningSettingsRequest}
     * @memberof UpgradeRuleResponse
     */
    disableExtendedVersioningSettings: DisableExtendedVersioningSettingsRequest | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgradeRuleResponse
     */
    stbGroups: Array<string>;
}

export function UpgradeRuleResponseFromJSON(json: any): UpgradeRuleResponse {
    return UpgradeRuleResponseFromJSONTyped(json, false);
}

export function UpgradeRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceTypeId': json['deviceTypeId'],
        'superGroupId': json['superGroupId'],
        'name': json['name'],
        'loaderVersionFirmwareId': json['loaderVersionFirmwareId'],
        'fwVersionFirmwareId': json['fwVersionFirmwareId'],
        'uiVersionFirmwareId': json['uiVersionFirmwareId'],
        'forceUpdate': json['forceUpdate'],
        'sendAllFirmwares': json['sendAllFirmwares'],
        'customFirmware1VersionId': json['customFirmware1VersionId'],
        'customFirmware2VersionId': json['customFirmware2VersionId'],
        'customFirmware3VersionId': json['customFirmware3VersionId'],
        'deviceTypeForceUpdate': json['deviceTypeForceUpdate'],
        'deviceTypeSendAllFirmwares': json['deviceTypeSendAllFirmwares'],
        'etc': UpgradeRuleEtcResponseFromJSON(json['etc']),
        'enableLoaderCondition': json['enableLoaderCondition'],
        'minLoaderVersion': json['minLoaderVersion'],
        'maxLoaderVersion': json['maxLoaderVersion'],
        'enableFwCondition': json['enableFwCondition'],
        'minFwVersion': json['minFwVersion'],
        'maxFwVersion': json['maxFwVersion'],
        'enableUiCondition': json['enableUiCondition'],
        'minUiVersion': json['minUiVersion'],
        'maxUiVersion': json['maxUiVersion'],
        'disableExtendedVersioningSettings': DisableExtendedVersioningSettingsRequestFromJSON(json['disableExtendedVersioningSettings']),
        'stbGroups': json['stbGroups'],
    };
}

export function UpgradeRuleResponseToJSON(value?: UpgradeRuleResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'superGroupId': value.superGroupId,
        'name': value.name,
        'loaderVersionFirmwareId': value.loaderVersionFirmwareId,
        'fwVersionFirmwareId': value.fwVersionFirmwareId,
        'uiVersionFirmwareId': value.uiVersionFirmwareId,
        'forceUpdate': value.forceUpdate,
        'sendAllFirmwares': value.sendAllFirmwares,
        'customFirmware1VersionId': value.customFirmware1VersionId,
        'customFirmware2VersionId': value.customFirmware2VersionId,
        'customFirmware3VersionId': value.customFirmware3VersionId,
        'deviceTypeForceUpdate': value.deviceTypeForceUpdate,
        'deviceTypeSendAllFirmwares': value.deviceTypeSendAllFirmwares,
        'etc': UpgradeRuleEtcResponseToJSON(value.etc),
        'enableLoaderCondition': value.enableLoaderCondition,
        'minLoaderVersion': value.minLoaderVersion,
        'maxLoaderVersion': value.maxLoaderVersion,
        'enableFwCondition': value.enableFwCondition,
        'minFwVersion': value.minFwVersion,
        'maxFwVersion': value.maxFwVersion,
        'enableUiCondition': value.enableUiCondition,
        'minUiVersion': value.minUiVersion,
        'maxUiVersion': value.maxUiVersion,
        'disableExtendedVersioningSettings': DisableExtendedVersioningSettingsRequestToJSON(value.disableExtendedVersioningSettings),
        'stbGroups': value.stbGroups,
    };
}

